/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RosettaAccountIdentifier,
    RosettaAccountIdentifierFromJSON,
    RosettaAccountIdentifierFromJSONTyped,
    RosettaAccountIdentifierToJSON,
    RosettaOperation,
    RosettaOperationFromJSON,
    RosettaOperationFromJSONTyped,
    RosettaOperationToJSON,
} from './';

/**
 * RosettaConstructionParseResponse contains an array of operations that occur in a transaction blob. This should match the array of operations provided to /construction/preprocess and /construction/payloads.
 * @export
 * @interface RosettaConstructionParseResponse
 */
export interface RosettaConstructionParseResponse {
    /**
     * 
     * @type {Array<RosettaOperation>}
     * @memberof RosettaConstructionParseResponse
     */
    operations: Array<RosettaOperation>;
    /**
     * [DEPRECATED by account_identifier_signers in v1.4.4] All signers (addresses) of a particular transaction. If the transaction is unsigned, it should be empty.
     * @type {Array<string>}
     * @memberof RosettaConstructionParseResponse
     */
    signers?: Array<string>;
    /**
     * 
     * @type {Array<RosettaAccountIdentifier>}
     * @memberof RosettaConstructionParseResponse
     */
    account_identifier_signers?: Array<RosettaAccountIdentifier>;
    /**
     * 
     * @type {object}
     * @memberof RosettaConstructionParseResponse
     */
    metadata?: object;
}

export function RosettaConstructionParseResponseFromJSON(json: any): RosettaConstructionParseResponse {
    return RosettaConstructionParseResponseFromJSONTyped(json, false);
}

export function RosettaConstructionParseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaConstructionParseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'operations': ((json['operations'] as Array<any>).map(RosettaOperationFromJSON)),
        'signers': !exists(json, 'signers') ? undefined : json['signers'],
        'account_identifier_signers': !exists(json, 'account_identifier_signers') ? undefined : ((json['account_identifier_signers'] as Array<any>).map(RosettaAccountIdentifierFromJSON)),
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
    };
}

export function RosettaConstructionParseResponseToJSON(value?: RosettaConstructionParseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'operations': ((value.operations as Array<any>).map(RosettaOperationToJSON)),
        'signers': value.signers,
        'account_identifier_signers': value.account_identifier_signers === undefined ? undefined : ((value.account_identifier_signers as Array<any>).map(RosettaAccountIdentifierToJSON)),
        'metadata': value.metadata,
    };
}

